export const addToFavorite = (id: number) => ({
  type: "@saga/ADD_TO_FAVORITE",
  payload: id,
});
